<template>
    <div class="modal-card" style="width: auto">
         <b-loading :is-full-page=true v-model="isLoadingFullPage" ></b-loading>
        <!-- <header class="modal-card-head" style="justify-content: space-between;">
     

        </header> -->
        <section class="modal-card-body">
            
 
 

                            <nav class="level is-mobile">
                                                    <div class="level-left">
                                                        <div class="level-item">
                                                            <b-upload v-model="dropFiles"
                                                                :disabled="dropFiles.length>=GLOBAL_VAR.MAX_IMAGE_UPLOAD_FOR_NEWS"
                                                                    multiple
                                                                    accept=".jpg,.jpeg,.png" 
                                                                    @input="inputBUpload"
                                                                    drag-drop>
                                                                    <section class="section">
                                                                        <div class="content has-text-centered">
                                                                            <p>
                                                                                <b-icon
                                                                                    icon="upload"
                                                                                    size="is-large">
                                                                                </b-icon>
                                                                            </p>
                                                                            <p>Drop your files here or click to upload (not over {{GLOBAL_VAR.MAX_IMAGE_UPLOAD_FOR_NEWS}})</p>
                                                                        </div>
                                                                    </section>
                                                                </b-upload>

                                                        </div>

                                                        <div class="level-item" v-if="dropFiles.length>0">
                                                        <span class="has-text-info is-size-4"  > จำนวนรูป {{dropFiles.length}} / {{GLOBAL_VAR.MAX_IMAGE_UPLOAD_FOR_NEWS}}  </span>
                                                        </div>   

                                                        <div class="level-item" v-if="dropFiles.length>GLOBAL_VAR.MAX_IMAGE_UPLOAD_FOR_NEWS">
                                                            <b-message type="is-danger"  >
                                                                Error  Max value is {{GLOBAL_VAR.MAX_IMAGE_UPLOAD_FOR_NEWS}}
                                                            </b-message> 
                                                    </div>   
                                                    </div>
                                                    <div class="level-right">
                                                        <div class="level-item">   
                                                        
                                                        </div>
                                                    </div>
                            </nav>






      <b-progress :value="valueProgress" 
                  :max="maxProgress"
                  size="is-large"
                  type="is-info" 
                  show-value v-if="showProgress"></b-progress>

 
 


            <div class="columns is-multiline">
                                 
                                    <div class="column is-one-quarter-desktop is-half-tablet"   v-for="(img,index) in getObjectURL" :key="img.url" >
                                            <div class="card">

                                                            <div class="card-content">
                                                                        <figure class="image is-4by3"  >
                                                                            <img :src="img.url"  >
                                                                        </figure>
                                                            </div>

                                                            <footer class="card-footer">

                                                                <a class="card-footer-item" @click="deleteDropFile(index)"  >
                                                                <span>
                                                                    <b-icon
                                                                            icon="delete"
                                                                            type = "is-danger"
                                                                            size="is-medium">
                                                                    </b-icon>
                                                                </span>
                                                                </a>


                                                            </footer>
                                            </div>
                                    </div>
 
            </div>


<!-- <img :src="my_photo" alt="Girl in a jacket" width="500" height="600"> -->
 

 
                      
        </section>
        <footer class="modal-card-foot"  style="justify-content: space-between;">
            <!-- {{checkSomeCaptionOverMaxOrNot}} -->
            <b-button type="is-danger" @click="close"  icon-left="close"  >Close</b-button>
            <b-button type="is-success" @click="upload"  icon-left="upload"  :disabled=" !saveBtnDisableCheck" >Save All</b-button>
            <b-button type="is-warning"  icon-left="close-outline"   :disabled="!dropFiles.length>0"    @click="clearImagesAll">clear All</b-button>
        </footer>
    </div>
</template>


<script>
import {  MAX_IMAGE_UPLOAD_FOR_NEWS   } from '@/utils.js'
import _ from 'lodash' 
import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios , }  from '@/utils.js'
import {  mapState } from "vuex";   
   


export default {
    name : "DlgImagesUploadBuffer",
    props:{
        isComponentModalActive :  {
                                        type: Boolean,
                                        default: false
                                    },  
        forJob :  {
                                        type: Number,
                                        default: -1 , // -1 for nothing , 0 == News , 1 == ManualCBCImage
                                    },                              
        forNews_id : Number,
        forIDLAB : String,
    },
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()

                next(false)
            })
            

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    computed:{
        ...mapState({
            access_token: state => state.master_data.access_token ,
            labNewsElement : state => state.lab_news_element.labNewsElement ,
            modeLabNewsElement : state => state.lab_news_element.modeLabNewsElement ,
        }),


        GLOBAL_VAR(){
                return { MAX_IMAGE_UPLOAD_FOR_NEWS  ,
                        }
        },
        getObjectURL(){

// console.log( this.dropFiles )
            //   return []
              
                return this.dropFiles.map(dat=>{
                    // console.log(typeof dat)
                    return {
                        "url" : URL.createObjectURL(dat),
                        "name" : dat.name
                    }
                })
        },   

        saveBtnDisableCheck(){
             
               if (this.dropFiles.length>0 && this.dropFiles.length<=MAX_IMAGE_UPLOAD_FOR_NEWS ) {
               
               
                 const tmpArr = this.dropFiles.map(dat=>dat.length>MAX_IMAGE_UPLOAD_FOR_NEWS)
                 const tmpFound = _.findIndex(tmpArr, function(o) { return o == true });
                //  console.log(tmp)
                //  if(tmp!=null){
                //      return  false 
                //  }

                 
                //  console.log(tmpFound)
                return tmpFound > -1 ? false :  true 
                //  return  true
                     
               }

               return false
            },
        
        
    },
    methods:{
                inputBUpload(){
                            // console.log(this.dropFiles)
                            // const data = URL.createObjectURL(this.dropFiles[0]);
                            // this.my_photo = data;
                            // console.log(this.dropFiles)
                },
                close(){
                        this.$emit('close')
                },

                async uploadNewsImages(){
                           // progress
                                this.showProgress = true
                                this.valueProgress = 1
                                this.maxProgress = this.dropFiles.length
                           
                                //
                                this.isLoadingFullPage = true
                                
                                for(var i=0;i<=this.dropFiles.length-1;i++){
                                    // console.log(this.dropFiles[i])
                                    const formData = new FormData()
                                    formData.append('file',this.dropFiles[i])
                                    formData.append('dat',`{ "news_id":  ${this.labNewsElement.id} , "order_display": ${i}  }`)
                                    // for (const value of formData.values()) {
                                    // console.log(value);
                                    // }

                                     


                                    try{
                                            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                                            await axios.post(`${getBaseURLforBackEnd()}/api/uploadimageslabnews`,formData,getConfigAxios())
                                                        .then((res)=>{
                                                            //  console.log(res)
                                                            this.$buefy.toast.open({
                                                                duration: 1000,
                                                                message: `${res.data.msg}`,
                                                                position: 'is-bottom',
                                                                type: 'is-danger'
                                                            })

                                                            // update progress
                                                            this.valueProgress++ 
                                                        })

                                            // this.file = ""
                                            this.error = false
                                        }catch (e) {
                                            console.log(' error : '+e)
                                            this.message = e.response.data.error
                                            this.error = true
                                            this.isLoadingFullPage = false
                                        }    


                                }



                                // stop spinner
                                this.showProgress = false
                                this.isLoadingFullPage = false


                                


                                // close
                                this.$emit('closeWithUpdate')



                                // notifies toast
                                this.$buefy.toast.open({
                                    duration: 2500,
                                    message: `update images completed`,
                                    position: 'is-bottom',
                                    type: 'is-success'
                                })  

                },
                async uploadCBCImages(){
                                // progress
                                this.showProgress = true
                                this.valueProgress = 1
                                this.maxProgress = this.dropFiles.length
                           
                                //
                                this.isLoadingFullPage = true
                                
                                for(var i=0;i<=this.dropFiles.length-1;i++){
                                    // console.log(this.dropFiles[i])
                                    const formData = new FormData()
                                    formData.append('file',this.dropFiles[i])
                                    formData.append('dat', `{ "idlab":   "${this.forIDLAB}"   }`)

                            
                                  
                                     


                                    try{
                                            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                                            await axios.post(`${getBaseURLforBackEnd()}/api/uploadimageslabcbc`,formData,getConfigAxios())
                                                        .then((res)=>{
                                                            //  console.log(res)
                                                            this.$buefy.toast.open({
                                                                duration: 1000,
                                                                message: `${res.data.msg}`,
                                                                position: 'is-bottom',
                                                                type: 'is-danger'
                                                            })

                                                            // update progress
                                                            this.valueProgress++ 
                                                        })

                                            // this.file = ""
                                            this.error = false
                                        }catch (e) {
                                            console.log(' error : '+e)
                                            this.message = e.response.data.error
                                            this.error = true
                                            this.isLoadingFullPage = false
                                        }    


                                }



                                // stop spinner
                                this.showProgress = false
                                this.isLoadingFullPage = false


                                


                                // close
                                this.$emit('closeWithUpdate')



                                // notifies toast
                                this.$buefy.toast.open({
                                    duration: 2500,
                                    message: `update images completed`,
                                    position: 'is-bottom',
                                    type: 'is-success'
                                })  

                },
                upload(){
                   if(this.forJob == 0){
                     this.uploadNewsImages()
                   }
                    if(this.forJob == 1){
                     this.uploadCBCImages()
                   }
                            


                },
                clearImagesAll(){
                    this.dropFiles = []
                },
                deleteDropFile(index) {
                            this.dropFiles.splice(index, 1)
                },
    },
    data(){
        return {
            isLoadingFullPage : false,
            dropFiles: [],

            showProgress : false,
            valueProgress : 0,
            maxProgress : 0,
        }
    }
}
</script>


<style scoped>
   img{
        cursor: pointer;
        width:100%;
        height:100%;
        object-fit: contain;

    }

    /* img:hover {
  
} */
    .card-footer:hover{
       border: 1px solid rgb(176, 172, 172);
    }

     



</style>